var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoScoreCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37563_88567)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 150,
    height: 150,
    rx: 75,
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103 127.417C103 148.358 86.0248 165.333 65.0832 165.333C44.1415 165.333 27.1665 148.358 27.1665 127.417C27.1665 106.475 44.1415 89.5 65.0832 89.5C66.0748 89.5 67.1248 89.5583 68.1165 89.6167C86.6082 91.075 101.425 105.892 102.883 124.383C102.942 125.375 103 126.425 103 127.417Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.833 86.5834C143.833 105.6 129.833 121.292 111.633 124.033V123.683C109.825 101.05 91.4501 82.6751 68.6418 80.8667H68.4668C71.2085 62.6667 86.9001 48.6667 105.917 48.6667C126.858 48.6667 143.833 65.6417 143.833 86.5834Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1082 48.6667H32.9998C29.7915 48.6667 27.1665 51.2917 27.1665 54.5001V69.6084C27.1665 74.8001 33.4665 77.4251 37.1415 73.7501L52.2498 58.6417C55.8665 54.9667 53.2998 48.6667 48.1082 48.6667Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.892 165.333H138C141.209 165.333 143.834 162.708 143.834 159.5V144.392C143.834 139.2 137.534 136.575 133.859 140.25L118.75 155.358C115.134 159.033 117.7 165.333 122.892 165.333Z",
    fill: "#CBD5E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37563_88567"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 150,
    height: 150,
    rx: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoScoreCard);
export default __webpack_public_path__ + "static/media/No-score-card.ea6901902b957e56522ec7037c724ce6.svg";
export { ForwardRef as ReactComponent };